import React from "react";

import { Panel, CloseButton } from "./style";

export default function LegalInformations({ isHome, state, hide }) {
  return (
    <Panel className={state} isHome={isHome}>
      <CloseButton onClick={hide} title="Fermer" />

      <h2>Conditions de jeu</h2>

      <p>Jeu accessible en ligne du 2 juillet au 4 août 2018.</p>

      <h3>Pour participer</h3>

      <p>Répondez à chacune des 10 questions, un seul choix possible.</p>
      <p>Gagnant si&nbsp;: 10 bonnes réponses</p>
      <p>Perdant si&nbsp;: 1 ou plusieurs erreurs.</p>
      <p>Vous pouvez rejouer autant de fois que vous le souhaitez.</p>

      <p>
        Si vous avez correctement répondu à l’ensemble des questions en une
        seule fois, remplissez les champs obligatoires. Vous recevrez par mail
        un bon d’achat d’une valeur de 15&nbsp;€ TTC à valoir pour tout achat de
        150&nbsp;€ TTC dans l’un des centres PIÈCES&nbsp;AUTO.
      </p>

      <p>
        Offre réservée aux particuliers sur présentation de l’email envoyé. Non
        cumulable avec d’autres offres en cours. Valable pour toutes prestations
        atelier ou achats en magasin, hors pneumatiques.
      </p>

      <p>Le bon d’achat est valable du 1er septembre au 31 octobre 2018.</p>

      <h3>Règlement</h3>

      <p>
        En cliquant, vous acceptez le règlement et les conditions d’utilisation
        des sites PIÈCES&nbsp;AUTO du groupe GROUPAUTO. Le groupe GROUPAUTO, en sa
        qualité de responsable du traitement, collecte vos données à caractère
        personnel pour les finalités suivantes : (i) participation à des
        jeux-concours (ii) inscription aux Newsletters (iii) proposition de
        messages et de contenus adaptés à votre profil (iv) réception des bons
        plans et offres commerciales du groupe GROUPAUTO.
      </p>
      <p>
        Conformément à la loi informatique et libertés du 6 janvier 1978, vous
        bénéficiez d’un droit d’accès, de rectification et de suppression de vos
        données. Vous pouvez également vous opposer, pour un motif légitime, à
        l’utilisation de vos données. Vous seul pouvez exercer ces droits sur
        vos propres données en écrivant à PIÈCES&nbsp;AUTO - Groupe GROUPAUTO - Service
        Marketing - 20 avenue André Malraux 92300 Levallois-Perret— et en
        signant une photocopie de votre pièce d’identité.
      </p>
    </Panel>
  );
}



// WEBPACK FOOTER //
// ./src/components/LegalInformations/index.js